

import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { LoaderService } from '../services/loader.service';

export const authInterceptorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const loader = inject(LoaderService);
  //  loader.changeStatus(true);
  // Exclude login API from adding token
  if (req.url.includes('/api/login') && !req.url.includes('/api/login/reset')) {
    // loader.changeStatus(false);
    return next(req);
  }

  // Retrieve token from sessionStorage
  const storedUserDetails = sessionStorage.getItem('userDetails');
  const authToken = storedUserDetails ? JSON.parse(storedUserDetails)?.token : null;
  // Clone request and add Authorization header if token exists
  const authReq = authToken
    ? req.clone({
        setHeaders: { Authorization: `Bearer ${authToken}` },
      })
    : req;
    // loader.changeStatus(false);

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      // If 401 Unauthorized, redirect to login
      if (error.status === 401) {
        sessionStorage.removeItem('userDetails'); // Clear invalid token
        // loader.changeStatus(false);
        router.navigate(['/login']); // Redirect to login page
      }
      
      return throwError(() => error);
    })
  );


};
